import { render, staticRenderFns } from "./CompanyMsgDetail.vue?vue&type=template&id=7b7bd348&scoped=true"
import script from "./CompanyMsgDetail.vue?vue&type=script&lang=ts"
export * from "./CompanyMsgDetail.vue?vue&type=script&lang=ts"
import style0 from "./CompanyMsgDetail.vue?vue&type=style&index=0&id=7b7bd348&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7bd348",
  null
  
)

export default component.exports